import { createAsyncThunk } from "@reduxjs/toolkit";
import { getFeatureFlags } from "../../utils/apiCallHandler/features";
import { actionLoadingStates } from "../../utils/stateEnums";

const { idle, pending, succeeded, failed } = actionLoadingStates;

export const initialState = {
  loading: idle,
  enabled: [],
};

export const loadFeatureFlags = createAsyncThunk(
  `features/load`,
  async ({ accessToken }) => {
    const response = await getFeatureFlags(accessToken);
    return response?.data;
  },
);

export const reducers = {
  loadFeatureFlags,
};

export const extraReducers = (builder) => {
  builder.addCase("features/load/pending", (state) => {
    return { ...state, loading: pending };
  });
  builder.addCase("features/load/fulfilled", (state, action) => {
    return {
      ...state,
      enabled: action.payload.enabled,
      loading: succeeded,
      justLoaded: true,
    };
  });
  builder.addCase("features/load/rejected", (state, action) => {
    return { ...state, error: action.error, loading: failed };
  });
};
